import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { BuildingEditForm } from "@/features/building/BuildingEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function BuildingEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/category-bizzpass",
            label: "Category BizzPass",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit Category BizzPass</H2>
      <BuildingEditForm id={id} />
    </>
  );
}
